define(['app', './base', './../translationsUtils/modal', 'magnific-popup'], function (
  app,
  Helper,
  TranslationModalSanatizer
) {
  return Helper.extend({
    options: {
      delegate: 'a.popup',
      type: false
    },

    bindGallery: function () {
      var opts = {
        type: this.options.type,
        delegate: this.options.delegate,
        gallery: {
          enabled: true,
          cursor: null
        },
        inline: { cursor: null },
        image: { cursor: null },
        callbacks: {
          elementParse: function (item) {
            if (item.src) return
            // Function will fire for each target element
            // "item.el" is a target DOM element (if present)
            // "item.src" is a source that you may modify
            item.src = item.el[0].src
          }
        }
      }
      var modalTranslations = app.translations
        ? TranslationModalSanatizer(app.translations.get('modal'))
        : {}

      opts = app._.deepExtend({}, modalTranslations, opts)
      this.$el.magnificPopup(opts)
    },

    initialize: function () {
      var self = this
      this.bindUIElements()

      if (!app.translations) {
        app.events.commands.setHandler('translations:mounted', function () {
          self.bindGallery()
        })
      }

      self.bindGallery()
    }
  })
})
